module.exports = __webpack_public_path__ + "assets/055fbccc22b06ffc541f4a315339ad1c.mp4";